<template>
  <div class="all_card_box">
    <div class="all_top">
        <img class="all_top_logo" src="../../assets/img/Logo.png" alt="">
    
        <div class="top_right_box1">
            <!-- 语言切换 -->
            <el-popover
                placement="bottom"
                popper-class="top_user lan_popover"
                width="70"
                v-model="visible_lan"
                trigger="click">
                <span slot="reference">
                    <span class="lan_icon" v-if="v_lan=='ch' ">简体中文</span>
                    <span class="lan_icon" v-else-if="v_lan=='jp' ">日本語</span>
                    <span class="lan_icon" v-else>English</span>
                    <i v-if="visible_lan" class="el-icon-caret-top u_r_icon2"></i>
                    <i v-else class="el-icon-caret-bottom u_r_icon2"></i>
                </span>
                <div class="u_box">
                    <div class="lan_list_item" @click="lang_fun('ch')">简体中文</div>
                    <div class="lan_list_item" @click="lang_fun('en')">English</div>
                    <div class="lan_list_item" @click="lang_fun('jp')">日本語</div>
                </div>  
            </el-popover>
        </div>

    </div>
    <div class="all_top_tit">
        <i @click="three_submit2" class="el-icon-back back_icon"></i>
        {{$t('main.text511')}}
    </div>

    <div class="th_info">
            <div class="th_info_top">
                <div class="info_top1">{{$t('main.text390')}}</div>
                <div class="info_top2">{{$t('main.text513')}}</div>
            </div>
            <div class="th_info_main">
                <!-- <div class="th_tit1">{{$t('main.text514')}}</div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text515')}}</div>
                    <div class="th_tit4">
                        目前就一种 先固定写
                        <span>{{$t('main.text516')}}</span>
                    </div>
                </div> -->

                <div class="th_tit1 title_bottom title_bottom2">{{$t('bank_card.Personal_Details')}}</div>
                <!-- <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text579')}}</div>
                    <div class="th_tit4">{{two_form_data.company_name}}</div>
                </div> -->
                <div class="th_tit2" v-if="ruiying!='ruiying'">
                    <div class="th_tit3">{{$t('main.text518')}}</div>
                    <div class="th_tit4">{{two_form_data.title}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text519')}}</div>
                    <div class="th_tit4">{{two_form_data.first_name}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text520')}}</div>
                    <div class="th_tit4">{{two_form_data.last_name}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text521')}}</div>
                    <div class="th_tit4">{{two_form_data.username}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text185')}}</div>
                    <div class="th_tit4">{{two_form_data.email}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text199')}}</div>
                    <div class="th_tit4"> +{{two_form_data.calling_code}} {{two_form_data.mobile_number}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text522')}}</div>
                    <div class="th_tit4">{{two_form_data.date_of_birth}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.Gender')}}</div>
                    <div class="th_tit4">{{two_form_data.gender}}</div>
                </div>
                <div class="th_tit2" v-if="company_type==0">
                    <div class="th_tit3">{{$t('main.text523')}}</div>
                    <div class="th_tit4">{{two_form_data.card_name}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text290')}}</div>
                    <div class="th_tit4">{{two_form_data.address}}</div>
                </div>
                <div class="th_tit2" v-if="two_form_data.secondary_address">
                    <div class="th_tit3">{{$t('main.text290')}} 2</div>
                    <div class="th_tit4">{{two_form_data.secondary_address}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text524')}}</div>
                    <div class="th_tit4">{{two_form_data.country}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text525')}}</div>
                    <div class="th_tit4">{{two_form_data.state}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text526')}}</div>
                    <div class="th_tit4">{{two_form_data.city}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text527')}}</div>
                    <div class="th_tit4">{{two_form_data.postal_code}}</div>
                </div>
                <!-- <div class="th_tit2" v-if="two_form_data.note">
                    <div class="th_tit3">{{$t('main.text620')}}</div>
                    <div class="th_tit4">{{two_form_data.note}}</div>
                </div> -->
                <div class="th_tit2" v-if="two_form_data.mail_address">
                    <div class="th_tit3">{{$t('main.text290')}} 1</div>
                    <div class="th_tit4">{{two_form_data.mail_address}}</div>
                </div>
                <div class="th_tit2" v-if="two_form_data.mail_secondary_address">
                    <div class="th_tit3">{{$t('main.text290')}} 2</div>
                    <div class="th_tit4">{{two_form_data.mail_secondary_address}}</div>
                </div>
                <div class="th_tit2" v-if="two_form_data.mail_country">
                    <div class="th_tit3">{{$t('main.text135')}}</div>
                    <div class="th_tit4">{{two_form_data.mail_country}}</div>
                </div>
                <div class="th_tit2" v-if="two_form_data.mail_state">
                    <div class="th_tit3">{{$t('main.text525')}}</div>
                    <div class="th_tit4">{{two_form_data.mail_state}}</div>
                </div>
                <div class="th_tit2" v-if="two_form_data.mail_city">
                    <div class="th_tit3">{{$t('main.text526')}}</div>
                    <div class="th_tit4">{{two_form_data.mail_city}}</div>
                </div>
                <div class="th_tit2" v-if="two_form_data.mail_postal_code">
                    <div class="th_tit3">{{$t('main.text527')}}</div>
                    <div class="th_tit4">{{two_form_data.mail_postal_code}}</div>
                </div>

                <div class="th_tit1 title_bottom">{{$t('main.text528')}}</div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text697')}}</div>
                    <div class="th_tit4">{{two_form_data.id_type||'-'}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text529')}}</div>
                    <div class="th_tit4">{{two_form_data.passport_number}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text530')}}</div>
                    <div class="th_tit4">{{two_form_data.issued_date}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text531')}}</div>
                    <div class="th_tit4">{{two_form_data.expiration_date}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text573')}}</div>
                    <div class="th_tit4">{{two_form_data.issued_by}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text578')}}</div>
                    <div class="th_tit4">{{two_form_data.language}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text532')}}</div>
                    <div class="th_tit4">
                        <template v-if="two_form_data.passport_front[0].includes('.pdf')||two_form_data.passport_front[0].includes('.PDF')">
                            <el-image style="width: 45px;cursor: pointer;" @click="open_pdf(two_form_data.passport_front[0])" :src='require("../../assets/img/pdf_icon2.png")' fit="contain"></el-image>
                        </template>
                        <template v-else>
                            <el-image 
                                v-for="(i, index) in two_form_data.passport_front" :key="index"
                                class="fd_img_box"
                                :src="i" 
                                :preview-src-list="[i]">
                            </el-image>
                        </template>
                    </div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text533')}}</div>
                    <div class="th_tit4">
                        <template v-if="two_form_data.passport_back[0].includes('.pdf')||two_form_data.passport_back[0].includes('.PDF')">
                            <el-image style="width: 45px;cursor: pointer;" @click="open_pdf(two_form_data.passport_back[0])" :src='require("../../assets/img/pdf_icon2.png")' fit="contain"></el-image>
                        </template>
                        <template v-else>
                            <el-image 
                                v-for="(i, index) in two_form_data.passport_back" :key="index"
                                class="fd_img_box"
                                :src="i" 
                                :preview-src-list="[i]">
                            </el-image>
                        </template>
                    </div>
                </div>
                <!-- 英文 -->
                <template v-if="company_type==0">
                    <div class="th_tit2" v-if="two_form_data.passport_front_en">
                        <div class="th_tit3">{{$t('main.text532')}}</div>
                        <div class="th_tit4">
                            <template v-if="two_form_data.passport_front_en[0].includes('.pdf')||two_form_data.passport_front_en[0].includes('.PDF')">
                                <el-image style="width: 45px;cursor: pointer;" @click="open_pdf(two_form_data.passport_front_en[0])" :src='require("../../assets/img/pdf_icon2.png")' fit="contain"></el-image>
                            </template>
                            <template v-else>
                                <el-image 
                                    v-for="(i, index) in two_form_data.passport_front_en" :key="index"
                                    class="fd_img_box"
                                    :src="i" 
                                    :preview-src-list="[i]">
                                </el-image>
                            </template>
                        </div>
                    </div>
                    <div class="th_tit2" v-if="two_form_data.passport_back_en">
                        <div class="th_tit3">{{$t('main.text532')}}</div>
                        <div class="th_tit4">
                            <template v-if="two_form_data.passport_back_en[0].includes('.pdf')||two_form_data.passport_back_en[0].includes('.PDF')">
                                <el-image style="width: 45px;cursor: pointer;" @click="open_pdf(two_form_data.passport_back_en[0])" :src='require("../../assets/img/pdf_icon2.png")' fit="contain"></el-image>
                            </template>
                            <template v-else>
                                <el-image 
                                    v-for="(i, index) in two_form_data.passport_back_en" :key="index"
                                    class="fd_img_box"
                                    :src="i" 
                                    :preview-src-list="[i]">
                                </el-image>
                            </template>
                        </div>
                    </div>
                </template>
                
                <div class="th_tit2" v-if="two_form_data.address_proof_additional.length">
                    <div class="th_tit3">{{$t('main.text157')}}</div>
                    <div class="th_tit4">
                        <div v-for="(i, index) in two_form_data.address_proof_additional" :key="index">
                            <template v-if="i.includes('.pdf')||i.includes('.PDF')">
                                <el-image style="width: 45px;cursor: pointer;" @click="open_pdf(i)" :src='require("../../assets/img/pdf_icon2.png")' fit="contain"></el-image>
                            </template>
                            <template v-else>
                                <el-image
                                    class="fd_img_box"
                                    :src="i"
                                    :preview-src-list="[i]">
                                </el-image>
                            </template>
                        </div>
                    </div>
                </div>
                

                <div class="th_tit1 title_bottom">{{$t('main.text534')}}</div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text534')}}</div>
                    <div class="th_tit4">
                        <template v-if="two_form_data.address_proof_front[0].includes('.pdf')||two_form_data.address_proof_front[0].includes('.PDF')">
                            <el-image style="width: 45px;cursor: pointer;" @click="open_pdf(two_form_data.address_proof_front[0])" :src='require("../../assets/img/pdf_icon2.png")' fit="contain"></el-image>
                        </template>
                        <template v-else>
                            <el-image 
                                v-for="(i, index) in two_form_data.address_proof_front" :key="index"
                                class="fd_img_box"
                                :src="i" 
                                :preview-src-list="[i]">
                            </el-image>
                        </template>
                    </div>
                </div>
                <div class="th_tit2" v-if="two_form_data.address_proof_back.length">
                    <div class="th_tit3">{{$t('main.text534')}}</div>
                    <div class="th_tit4">
                        <template v-if="two_form_data.address_proof_back[0].includes('.pdf')||two_form_data.address_proof_back[0].includes('.PDF')">
                            <el-image style="width: 45px;cursor: pointer;" @click="open_pdf(two_form_data.address_proof_back[0])" :src='require("../../assets/img/pdf_icon2.png")' fit="contain"></el-image>
                        </template>
                        <template v-else>
                            <el-image 
                                v-for="(i, index) in two_form_data.address_proof_back" :key="index"
                                class="fd_img_box"
                                :src="i" 
                                :preview-src-list="[i]">
                            </el-image>
                        </template>
                    </div>
                </div>
                <!-- 英文版 -->
                <template v-if="company_type==0">
                    <div class="th_tit2" v-if="two_form_data.address_proof_front_en.length">
                        <div class="th_tit3">{{$t('main.text532')}}</div>
                        <div class="th_tit4">
                            <template v-if="two_form_data.address_proof_front_en[0].includes('.pdf')||two_form_data.address_proof_front_en[0].includes('.PDF')">
                                <el-image style="width: 45px;cursor: pointer;" @click="open_pdf(two_form_data.address_proof_front_en[0])" :src='require("../../assets/img/pdf_icon2.png")' fit="contain"></el-image>
                            </template>
                            <template v-else>
                                <el-image 
                                    v-for="(i, index) in two_form_data.address_proof_front_en" :key="index"
                                    class="fd_img_box"
                                    :src="i" 
                                    :preview-src-list="[i]">
                                </el-image>
                            </template>
                        </div>
                    </div>
                    <div class="th_tit2" v-if="two_form_data.address_proof_back_en.length">
                        <div class="th_tit3">{{$t('main.text532')}}</div>
                        <div class="th_tit4">
                            <template v-if="two_form_data.address_proof_back_en[0].includes('.pdf')||two_form_data.address_proof_back_en[0].includes('.PDF')">
                                <el-image style="width: 45px;cursor: pointer;" @click="open_pdf(two_form_data.address_proof_back_en[0])" :src='require("../../assets/img/pdf_icon2.png")' fit="contain"></el-image>
                            </template>
                            <template v-else>
                                <el-image 
                                    v-for="(i, index) in two_form_data.address_proof_back_en" :key="index"
                                    class="fd_img_box"
                                    :src="i" 
                                    :preview-src-list="[i]">
                                </el-image>
                            </template>
                        </div>
                    </div>
                </template>
                

                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text576')}}</div>
                    <div class="th_tit4">{{two_form_data.address_type}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text535')}}</div>
                    <div class="th_tit4">{{two_form_data.address_issued_by}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text536')}}</div>
                    <div class="th_tit4">{{two_form_data.address_issued_date}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text578')}}</div>
                    <div class="th_tit4">{{two_form_data.address_language}}</div>
                </div>


                <template v-if="submit_dab">
                    <div class="btn_box">{{$t('main.text400')}}</div>
                </template>
                <template v-else>
                    <div class="btn_box" @click="three_submit">{{$t('main.text400')}}</div>
                </template>

            </div>
    </div>

    <!-- 卡片信息填写完成 我们会联系你 -->
    <el-dialog
      :visible.sync="card_ok_dlg"
      custom-class="log_out_dlg_bgc"
      append-to-body
      center
      @close="card_close_fun"
      :show-close="false"
      width="480px">
      <div class="log_out1">
          <img style="width:35px;" src="../../assets/img/Pigeon_icon.png" alt="">
      </div>
      <div class="log_out2 padding1">
        {{$t('main.text537')}}
      </div>
      <div class="log_out3">
        {{$t('new1_txt.dlg_txt1')}}
        <span class="link_to_bgc" @click="open_pdf(beth_url)">{{beth_url}}</span>
        {{$t('new1_txt.dlg_txt2')}}
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" class="confirm_btn2" @click="card_ok_dlg=false">{{$t('main.text266')}}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import {beth_addr} from '@/utils/base_address.js';
import {linkSubmit_str} from '@/api/api';
import cryptoJS from 'crypto-js'
export default {
  data() {
    return {
      card_ok_dlg:false,
      two_form_data:{
        passport_front: [],
        passport_back: [],
        address_proof_front:[],
        address_proof_back:[],

        passport_front_en:[],// id language语言非英文 正面照片数组
        passport_back_en:[],// d language语言非英文 背面照片数组
        address_proof_front_en:[],// 地址 语言非英文 正面
        address_proof_back_en:[],// 地址语言非英文 背面
      },
      card_type:'',// 1  2  两种银行卡类型 目前只可以用第一种 第二种还没有开发

      visible_lan:false,
      // company_type 0 链接申请卡正常显示 1去掉card-name等字段
      company_type:sessionStorage.getItem("company_type"),
      ruiying:localStorage.getItem("ruiying"),
      submit_dab:false,
      link_data:{},
      beth_url:beth_addr,
    }
  },
  beforeDestroy(){
    sessionStorage.removeItem('top_title_name');
  },
  beforeMount(){
    this.two_form_data=JSON.parse(localStorage.getItem("two_form_data"));
    // this.card_type=JSON.parse(localStorage.getItem("card_type"));
    // console.log(this.two_form_data);
  },
  mounted() {
    sessionStorage.setItem('top_title_name',this.$t('main.text511'));
    if(sessionStorage.getItem('card_link_d')){
        this.link_data = JSON.parse(sessionStorage.getItem('card_link_d'));
    }
  },
  methods: {
    three_submit(){
        this.submit_dab=true;
        let key= "6P7t47zj3dnh5isx";
        let iv= "hrYjdyJ2nBjdKB6G";
        let word={
            userid: this.link_data.userid,
            type: 1,
            apply_id: this.link_data.apply_id,
            country_code:sessionStorage.getItem("country_code_3"),
            calling_country_code:sessionStorage.getItem("calling_country_code_3"),
            details:this.two_form_data,
            issued_by_short_name: sessionStorage.getItem("issued_by_short_name_3"),
        }
        // console.log(word);
        let str1 =this.cryptojsEncrypt(JSON.stringify(word),key,iv);
        linkSubmit_str({str:str1}).then(res=>{
            this.submit_dab=false;
            if(res.data.code==200){
                // console.log(res.data.data);
                this.card_ok_dlg=true;
            }else{
                this.three_submit2();
                this.message.ismessage("error",res.data.msg);
            }
        }).catch(err=>{
          console.log(err);
          this.submit_dab=false;
        })
    },
    card_close_fun(){
        this.$router.go(-1);
    },
    cryptojsEncrypt(word, keyStr, ivStr) {
        let key = cryptoJS.enc.Utf8.parse(keyStr);
        let iv = cryptoJS.enc.Utf8.parse(ivStr);
        let srcs = cryptoJS.enc.Utf8.parse(word);

        let encrypted = cryptoJS.AES.encrypt(srcs, key, {
            iv,
            mode: cryptoJS.mode.CBC,
            padding: cryptoJS.pad.Pkcs7
        });
        return encrypted.toString();
    },
    lang_fun(v) {
        localStorage.setItem("language", v);
        setTimeout(() => {
            location.reload();
        }, 100);
    },
    three_submit2(){
        this.$router.go(-1);
        this.$nextTick(()=>{
            setTimeout(() => {
                this.$nextTick(()=>{
                    this.bus.$emit("all_err_return");
                })
            }, 200);
        })
    },
    open_pdf(v){
        window.open(v , "_blank");
    }

  },

}
</script>

<style scoped>
/* --表 table-- */
.th_info{
    background: #314B69;
    border-radius: 16px;
}
.th_info_top{
    box-sizing: border-box;
    padding: 28px;
    border-bottom: 1.5px solid #041E35;
}
.info_top1{
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
    margin-bottom: 4px;
}
.info_top2{
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.6);
}
.th_info_main{
    box-sizing: border-box;
    padding: 28px;
}
.th_tit1{
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 18px;
    margin-bottom: 12px;
}
.th_tit2{
    margin-bottom: 12px;
    display: flex;
}
.th_info_main .th_tit2:last-child{
    margin-bottom: 0;
}
.th_tit3{
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 18px;
    color: rgba(255, 255, 255, 0.6);
    width: 160px;
    margin-right: 28px;
    display: inline-block;
}
.th_tit4{
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    display: inline-block;
}
.title_bottom{
    margin-top: 40px;
}
.btn_box{
    min-width: 292px;
    height: 38px;
    text-align: center;
    line-height: 38px;
    background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
    box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
    border-radius: 4px;
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    color: #04182A;
    margin-top: 40px;
    display: inline-block;
    cursor: pointer;
}
/* ---- */
.fd_img_box{
    max-width: 260px;
    max-height: 160px;
    display: block;
    margin-bottom: 5px;
}
.fd_img_box2{
    max-width: 260px;
    max-height: 160px;
    display: block;
    margin-bottom: 12px;
}
/* ------ */
.all_card_box{
    background: #041E35;
    box-sizing: border-box;
    padding-bottom: 60px;
    color: #fff;
}
.all_top{
    height: 104px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #041728;
    position: relative;
}
.all_top_logo{
    max-width: 200px;
}
.th_info{
    box-sizing: border-box;
    margin: 0 200px;
}
.all_top_tit{
    font-style: normal;
    font-weight: 700;
    font-size: 28px;
    box-sizing: border-box;
    margin: 60px 200px 40px;
}
.title_bottom2{
    margin-top: 0;
}
.back_icon{
  font-size: 28px;
  color: #fff;
  margin-right: 10px;
  cursor: pointer;
}
/* 语言切换 */
.lan_icon{
  width: 28px;
  height: 28px;
  vertical-align: middle;
  cursor: pointer;
  color: rgb(222, 185, 129);
}
.top_right_box1{
  /* margin-right: 30px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 20px; */
  position: absolute;
  right: 40px;
}
.u_r_icon2{
  margin-left: 8px;
  cursor: pointer;
  margin-top: 5px;
  color: rgb(222, 185, 129);
}
.lan_list_item{
    cursor: pointer;
  /* width: 28px;
  height: 28px; */
  margin: 10px auto;
  display: block;
}
.head_title2{
  /* max-width: 70%; */
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
/* .top_right_box1 > span{
  border: 1px solid rgba(49, 72, 105, 0.2);
  box-sizing: border-box;
  padding: 2px 6px;
  border-radius: 4px;

} */

/* ------ */
.link_to_bgc{
    color: rgb(239, 195, 129);
    cursor: pointer;
}
</style>

<style>
/* 语言 */
.top_user{
  color: #fff;
  font-size: 15px;
  background: #03101C;
  box-shadow: 0px 4px 8px #03101C;
  border-radius: 16px;
  border: none;
}
.top_user[x-placement^=bottom] .popper__arrow,
.top_user[x-placement^=bottom] .popper__arrow::after{
  display: none;
  border-bottom-color: transparent;
}
.top_user .popper__arrow{
  display: none;
}
.lan_popover{
  min-width: 70px;
  transform: translateX(-3px);
}
/* ---- */
</style>

<style>
.log_out_dlg_bgc {
    background: #041E35 !important;
}
</style>

<style scoped>
  /* 手机端 */
@media screen and (max-width: 850px) {
    .d_row {
        display: block;
    }
    .d_row>div {
        width: auto;
    }
    .zdy_form_style >>> .el-form-item__label {
        height: auto !important;
    }
    .top_right_box1 {
        right: 27px;
    }
    .all_top_tit {
        margin: 20px;
    }
    .th_info {
        margin: 20px;
    }

}
</style>
